import { FaBasketShopping, FaBomb, FaRecordVinyl } from "react-icons/fa6";

function timeAgo(timestamp: number): string {
    const now = Date.now();
    const diff = now - timestamp;

    const seconds = Math.floor(diff / 1000);
    const minutes = Math.floor(diff / (1000 * 60));
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const weeks = Math.floor(diff / (1000 * 60 * 60 * 24 * 7));
    const months = Math.floor(diff / (1000 * 60 * 60 * 24 * 30));
    const years = Math.floor(diff / (1000 * 60 * 60 * 24 * 365));

    if (seconds < 60) return `${seconds} sec${seconds !== 1 ? "s" : ""} ago`;
    if (minutes < 60) return `${minutes} min${minutes !== 1 ? "s" : ""} ago`;
    if (hours < 24) return `${hours} hour${hours !== 1 ? "s" : ""} ago`;
    if (days < 7) return `${days} day${days !== 1 ? "s" : ""} ago`;
    if (weeks < 5) return `${weeks} week${weeks !== 1 ? "s" : ""} ago`;
    if (months < 12) return `${months} month${months !== 1 ? "s" : ""} ago`;
    return `${years} year${years !== 1 ? "s" : ""} ago`;
}

interface Props {
    title: string;
    text?: string;
    time: number;
    user?: string;
    type: "shop" | "sound" | "throwable";
}

export function FeedItem(props: Props) {
    return (
        <div
            className="feed-item-container"
            style={{
                display: "flex",
                flexDirection: "row",
                width: "100%",
                borderBottom: "1px solid gray",
            }}
        >
            {props.type === "shop" && <FaBasketShopping />}
            {props.type === "sound" && <FaRecordVinyl />}
            {props.type === "throwable" && <FaBomb />}
            <div
                className="feed-body"
                style={{
                    color: "white",
                    padding: "0.25em",
                    flexGrow: "1",
                }}
            >
                <div
                    className="feed-row-1"
                    style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "flex-end",
                        marginBottom: "0.25em",
                    }}
                >
                    <span
                        className="feed-title"
                        style={{ margin: "0 0.25em", fontWeight: "bold" }}
                    >
                        {props.title}
                    </span>
                    •
                    <span className="feed-user" style={{ margin: "0 0.25em" }}>
                        {props.user}
                    </span>
                    <span
                        className="feed-time"
                        style={{
                            textAlign: "left",
                            color: "lightgray",
                            fontSize: "12px",
                        }}
                    >
                        {timeAgo(props.time)}
                    </span>
                </div>
                {props.text && (
                    <div
                        className="feed-text"
                        style={{
                            textAlign: "left",
                            color: "lightgray",
                            fontSize: "14px",
                            fontStyle: "italic",
                            marginLeft: "1em",
                            paddingLeft: "0.5em",
                            borderLeft: "2px solid lightgray",
                            backgroundColor: "rgba(0,0,0,0.3)",
                        }}
                    >
                        {props.text}
                    </div>
                )}
            </div>
        </div>
    );
}
